import { render, staticRenderFns } from "./PopupProperties.vue?vue&type=template&id=4f3e0482"
import script from "./PopupProperties.vue?vue&type=script&lang=js"
export * from "./PopupProperties.vue?vue&type=script&lang=js"
import style0 from "./PopupProperties.vue?vue&type=style&index=0&id=4f3e0482&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports